/**
 * Navigation Structure - Reorganized with better hierarchy
 */

import {
  LayoutDashboard,
  Wallet,
  ShieldCheck,
  Scale,
  Settings,
  User,
  Plug,
  ScrollText,
  BookOpen,
  KeyRound,
  Building2,
  FileCheck,
  Handshake,
  DollarSign,
  Crown,
  Users,
  Upload,
  ClipboardList,
  Compass,
  Briefcase,
  MessageSquare,
  BarChart3,
  Bell,
  FileText,
  CreditCard,
  Globe,
  Clock,
  CheckSquare,
  LogOut,
} from 'lucide-react'

/* ============================================================
   PLATFORM ADMIN NAVIGATION
   ============================================================ */
export const PLATFORM_NAV = [
  { 
    id: 'overview', 
    label: 'Overview', 
    icon: 'LayoutDashboard', 
    route: 'overview' 
  },
  { 
    id: 'companies', 
    label: 'Companies', 
    icon: 'Building2', 
    route: 'companies' 
  },
  { 
    id: 'doc-queue', 
    label: 'Document Queue', 
    icon: 'FileCheck', 
    route: 'doc-queue' 
  },
  { 
    id: 'agent-requests', 
    label: 'Agent Requests', 
    icon: 'Handshake', 
    route: 'agent-requests' 
  },
  { 
    id: 'revenue', 
    label: 'Revenue', 
    icon: 'DollarSign', 
    route: 'revenue' 
  },
  { 
    id: 'investors', 
    label: 'Investors', 
    icon: 'Users', 
    route: 'investors' 
  },
  { 
    id: 'agents', 
    label: 'Agents', 
    icon: 'Briefcase', 
    route: 'agents' 
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Settings',
    children: [
      { id: 'platform-settings', label: 'Platform Settings', route: 'platform-settings' },
      { id: 'logout', label: 'Logout', icon: 'LogOut', route: 'logout' },
    ],
  },
]

/* ============================================================
   FOUNDER NAVIGATION
   ============================================================ */
export const COMPANY_NAV = [
  { 
    id: 'dashboard', 
    label: 'Dashboard', 
    icon: 'LayoutDashboard', 
    route: 'dashboard' 
  },
  {
    id: 'finance',
    label: 'Finance',
    icon: 'Wallet',
    children: [
      { id: 'ledger', label: 'Ledger', route: 'ledger' },
      { id: 'reports', label: 'Reports', route: 'reports' },
      // ✅ Moved Billing to Settings (removed from here)
    ],
  },
  {
    id: 'governance',
    label: 'Governance',
    icon: 'ShieldCheck',
    children: [
      { id: 'legal', label: 'Legal & Compliance', route: 'legal' },
      { id: 'staff-approvals', label: 'Staff Approvals', icon: 'CheckSquare', route: 'staff-approvals' },
      { id: 'audit-logs', label: 'Audit Logs', route: 'audit-logs' },
      { id: 'approvals', label: 'Investor Approvals', route: 'approvals' },
      { id: 'tasks', label: 'Compliance Tasks', route: 'tasks' },
    ],
  },
  { 
    id: 'investor', 
    label: 'Investor Portal', 
    icon: 'Crown', 
    route: 'investor' 
  },
  { 
    id: 'staff', 
    label: 'Staff Management', 
    icon: 'Users', 
    route: 'staff' 
  },
  { 
    id: 'messages', 
    label: 'Messages', 
    icon: 'MessageSquare', 
    route: 'messages' 
  },
  // ✅ Removed Discover from founder sidebar
  // { 
  //   id: 'discover', 
  //   label: 'Discover', 
  //   icon: 'Compass', 
  //   route: 'discover' 
  // },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Settings',
    children: [
      { id: 'profile', label: 'Profile', route: 'profile' },
      { id: 'brand', label: 'Brand', route: 'brand' },
      { id: 'integrations', label: 'Integrations', route: 'integrations' },
      { id: 'preferences', label: 'Preferences', route: 'preferences' },
      { id: 'billing', label: 'Billing', icon: 'CreditCard', route: 'billing' }, // ✅ Moved here
      { id: 'logout', label: 'Logout', icon: 'LogOut', route: 'logout' },
    ],
  },
]

/* ============================================================
   STAFF NAVIGATION
   ============================================================ */
export const STAFF_NAV = [
  { 
    id: 'ledger', 
    label: 'My Ledger', 
    icon: 'BookOpen', 
    route: 'ledger' 
  },
  { 
    id: 'docs', 
    label: 'Documents', 
    icon: 'FileText', 
    route: 'docs' 
  },
  { 
    id: 'tasks', 
    label: 'My Tasks', 
    icon: 'ClipboardList', 
    route: 'tasks' 
  },
  { 
    id: 'activity', 
    label: 'Team Activity', 
    icon: 'Users', 
    route: 'activity' 
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Settings',
    children: [
      { id: 'staff-profile', label: 'My Profile', route: 'staff-profile' },
      { id: 'staff-preferences', label: 'Preferences', route: 'staff-preferences' },
      { id: 'logout', label: 'Logout', icon: 'LogOut', route: 'logout' },
    ],
  },
]

/* ============================================================
   INVESTOR NAVIGATION (For investor view)
   ============================================================ */
export const INVESTOR_NAV = [
  { 
    id: 'vault', 
    label: 'Vault', 
    icon: 'Lock', 
    route: 'vault' 
  },
  { 
    id: 'documents', 
    label: 'Documents', 
    icon: 'FileText', 
    route: 'documents' 
  },
  { 
    id: 'discover', 
    label: 'Discover', 
    icon: 'Compass', 
    route: 'discover' 
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Settings',
    children: [
      { id: 'investor-profile', label: 'Profile', route: 'investor-profile' },
      { id: 'logout', label: 'Logout', icon: 'LogOut', route: 'logout' },
    ],
  },
]

/* ============================================================
   AGENT NAVIGATION
   ============================================================ */
export const AGENT_NAV = [
  { 
    id: 'agent-projects', 
    label: 'Projects', 
    icon: 'Briefcase', 
    route: 'agent-projects' 
  },
  { 
    id: 'agent-chat', 
    label: 'Chat', 
    icon: 'MessageSquare', 
    route: 'agent-chat' 
  },
  { 
    id: 'agent-upload', 
    label: 'Upload', 
    icon: 'Upload', 
    route: 'agent-upload' 
  },
  // ✅ Removed Discover from agent sidebar
  // { 
  //   id: 'discover', 
  //   label: 'Discover', 
  //   icon: 'Compass', 
  //   route: 'discover' 
  // },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Settings',
    children: [
      { id: 'agent-profile', label: 'Profile', route: 'agent-profile' },
      { id: 'logout', label: 'Logout', icon: 'LogOut', route: 'logout' },
    ],
  },
]

// Backwards compatibility
export const NAV = COMPANY_NAV

// Icon mapping for dynamic imports
export const sectionIcons = {
  audit: 'ScrollText',
  legal: 'Scale',
  tokens: 'KeyRound',
  ledger: 'BookOpen',
  profile: 'User',
  integrations: 'Plug',
  preferences: 'Settings',
  discover: 'Compass',
  agents: 'Briefcase',
  billing: 'CreditCard',
  reports: 'BarChart3',
  notifications: 'Bell',
  'staff-approvals': 'CheckSquare',
  logout: 'LogOut',
}